// extracted by mini-css-extract-plugin
export default {"buttons":"dialog_buttons__r1lEn","detailsRow":"dialog_detailsRow__Yac4n","detailHeading":"dialog_detailHeading__XcrnI","title":"dialog_title__IeBdl","value":"dialog_value__kifNE"};